module.exports = __webpack_public_path__ + "static/media/4_of_hearts.d34688bb.png";